import { createEntityAdapter } from '@reduxjs/toolkit';
import { BasketParams } from '../baskets.types';

const adapter = createEntityAdapter<BasketParams>();

export default adapter;
